import Vue from "vue";
import VueRouter from "vue-router";

import Contents from "@/components/Contents.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: { name: "page", params: { id: "ก" } }
  },
  {
    path: "/page/:id",
    name: "page",
    component: Contents
  },
  {
    path: "/word/:id",
    name: "word",
    component: Contents
  },
  {
    path: "/strategy/:id",
    name: "strategy",
    component: Contents
  },
  {
    path: "/reform/:id",
    name: "reform",
    component: Contents
  },
  {
    path: "/masterplan/:id",
    name: "masterplan",
    component: Contents
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  linkExactActiveClass: "active",
  routes
});

export default router;
